import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from '@/auth/AuthProvider';

import { AppRoutes } from './routes/AppRoutes';

/**
 * The QueryClient is created once. Sensible defaults: ~30s freshness so
 * hopping between pages doesn't refetch the same data, no auto-retry on
 * mutations (we surface errors via the form), refetch-on-window-focus
 * stays on so a CA returning to a tab gets fresh numbers.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* basename matches Laravel's `/panel/{any?}` route + Vite `base: '/panel/'` */}
      <BrowserRouter basename="/panel">
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          // keep the toast styling on-brand without overriding lib defaults too aggressively
          className: '!bg-surface !text-ink !border !border-line !shadow-card',
          style: { fontSize: 14 },
        }}
      />
    </QueryClientProvider>
  );
}
